const API_URL = process.env.REACT_APP_API_URL || "";

// API za rad s mapama
export async function getMaps() {
  const res = await fetch(`${API_URL}/api/maps`);
  return res.json();
}

export async function addMap({ name, key, img }) {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("key", key);
  formData.append("img", img);
  const res = await fetch(`${API_URL}/api/maps`, {
    method: "POST",
    body: formData,
  });
  return res.json();
}
